export const hlzWorksTxt = [
  {
    id: 1,
    // link: 'https://www.google.com',
    image: require('../images/ComponentImg/Works/Work Sensor 5.5 FF 1-1.jpg'),
    title: '5.5" Film Film Sensor',
    // subtitle: '5.5"'
  },
  {
    id: 2,
    // link: 'https://www.google.com',
    image: require('../images/ComponentImg/Works/Work Sensor 5.5 FF 1-2.jpg'),
    title: '5.5" Film Film Sensor',
    // subtitle: '5.5"'
  },
  {
    id: 3,
    // link: 'https://www.google.com',
    image: require('../images/ComponentImg/Works/Work Sensor 5.5 FF_fog 1-1.jpg'),
    title: '5.5" Film Film FOG Sensor',
  },
  {
    id: 4,
    image: require('../images/ComponentImg/Works/Work Sensor 5.5 FF_fog 1-2.jpg'),
    title: '5.5" Film Film FOG Sensor',
  },
  {
    id: 5,
    image: require('../images/ComponentImg/Works/Work Sensor 5.5 GS_fog 1-1.jpg'),
    title: '5.5" DITO Glass Sensor',
  },
  {
    id: 6,
    image: require('../images/ComponentImg/Works/Work Sensor 5.5 GS_fog 1-2.jpg'),
    title: '5.5" DITO Glass Sensor',
  },
  {
    id: 7,
    image: require('../images/ComponentImg/Works/Work Sensor 10.1 GS 1-1.jpg'),
    title: '10.1" DITO Glass Sensor',
  },
  {
    id: 8,
    image: require('../images/ComponentImg/Works/Work Sensor 10.1 GS 1-2.jpg'),
    title: '10.1" DITO Glass Sensor',
  },
  {
    id: 9,
    image: require('../images/ComponentImg/Works/Work TPM 5.5 PG 1-1.jpg'),
    title: '5.5" P+G PCap Touch Panel',
  },
  {
    id: 10,
    image: require('../images/ComponentImg/Works/Work TPM 5.5 PG 1-3.jpg'),
    title: '5.5" P+G PCap Touch Panel',
  },
  {
    id: 11,
    image: require('../images/ComponentImg/Works/Work TPM 7.0 GFF 1-1.jpg'),
    title: '7.0" P+G PCap Touch Panel',
  },
  {
    id: 12,
    image: require('../images/ComponentImg/Works/Work TPM 7.0 GFF 1-3.jpg'),
    title: '7.0" P+G PCap Touch Panel',
  },
  {
    id: 13,
    image: require('../images/ComponentImg/Works/Work TPM 10.1 GG 1-1.jpg'),
    title: '10.1" G+G PCap Touch_Panel',
  },
  {
    id: 14,
    image: require('../images/ComponentImg/Works/Work TPM 10.1 GG 1-2.jpg'),
    title: '10.1" G+G PCap Touch_Panel',
    // subtitle: '10.1"'
  },
  {
    id: 15,
    image: require('../images/ComponentImg/Works/Work TPM 12.1 GG_ARAF 1-1.jpg'),
    title: '12.1" G+G PCap Touch_Panel w/ ARAF',
  },
  {
    id: 16,
    image: require('../images/ComponentImg/Works/Work TPM 12.1 GG_ARAF 1-2.jpg'),
    title: '12.1" G+G PCap Touch_Panel w/ ARAF',
    // subtitle: '10.1"'
  },
  {
    id: 25,
    image: require('../images/ComponentImg/Works/Work TPM 21.5 GG 1-1.jpg'),
    title: '21.5" G+G PCap Touch_Panel',
  },
  {
    id: 17,
    image: require('../images/ComponentImg/Works/Work TPM O GG 1-1.jpg'),
    title: 'Round G+G PCap Touch_Panel',
  },
  {
    id: 18,
    image: require('../images/ComponentImg/Works/Work TPM O GG 1-3.jpg'),
    title: 'Round G+G PCap Touch_Panel',
    // subtitle: '10.1"'
  },
  {
    id: 19,
    image: require('../images/ComponentImg/Works/Work TDM 10.1 OpticsBond 1-1.jpg'),
    title: '10.1" TP+LCM Direct_Bonding',
  },
  {
    id: 20,
    image: require('../images/ComponentImg/Works/Work TDM 10.1 OpticsBond 1-2.jpg'),
    title: '10.1" TP+LCM Direct_Bonding',
  },
  {
    id: 21,
    image: require('../images/ComponentImg/Works/Work TDM 21.5 AirBond 1-1.jpg'),
    title: '21.5" TP+LCM AirGap_Bonding',
  },
  {
    id: 22,
    image: require('../images/ComponentImg/Works/Work TDM 21.5 AirBond 1-2.jpg'),
    title: '21.5" TP+LCM AirGap_Bonding',
  },
  {
    id: 23,
    image: require('../images/ComponentImg/Works/Work TDM 7.0 OpticsBond 1-2.jpg'),
    title: '7.0" TP+LCM Direct_Bonding',
  },
  {
    id: 24,
    image: require('../images/ComponentImg/Works/Work TPM 15.6 GG 1-1.jpg'),
    title: '15.6" TP+LCM Direct_Bonding',
  },
]
